import { tkVuexStorage } from '@moke/vue-tk'
import config from '../assets/js/config'
import store from '../store'
tkVuexStorage.init(store, config.vuexStorageKeys)
let storageStore = tkVuexStorage.restoreStorage()
store.commit('initFromStorage', storageStore)
